import React, {useEffect, useState} from 'react';
import {parseLocalDate} from "../utils/utils";

const DateSelector = ({ value, onChange, dayRef, monthRef, yearRef, minYear = null, maxYear = null }) => {
    // Initialize day, month, year from existing date value
    const parseDateValue = (dateStr) => {
        if (dateStr) {
            const date = parseLocalDate(dateStr);
            if (date) {
                return {
                    day: date.getDate(),
                    month: date.getMonth() + 1,
                    year: date.getFullYear()
                };
            }
        }
        return { day: '', month: '', year: '' };
    };

    const initialDateParts = parseDateValue(value);
    const [day, setDay] = useState(initialDateParts.day);
    const [month, setMonth] = useState(initialDateParts.month);
    const [year, setYear] = useState(initialDateParts.year);

    // Update when external value changes
    useEffect(() => {
        const parts = parseDateValue(value);
        setDay(parts.day);
        setMonth(parts.month);
        setYear(parts.year);
    }, [value]);

    // Generate arrays for select options
    const generateDays = () => {
        const days = [];
        let maxDays = 31;
        
        if (month && year) {
            // Get the number of days in the selected month/year
            maxDays = new Date(year, month, 0).getDate();
        } else if (month) {
            // If only month is selected, use a safe default (assuming non-leap year)
            const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            maxDays = daysInMonth[month - 1] || 31;
        }
        
        for (let i = 1; i <= maxDays; i++) {
            days.push(i);
        }
        return days;
    };

    const generateMonths = () => {
        return [
            { value: 1, label: 'Janeiro' },
            { value: 2, label: 'Fevereiro' },
            { value: 3, label: 'Março' },
            { value: 4, label: 'Abril' },
            { value: 5, label: 'Maio' },
            { value: 6, label: 'Junho' },
            { value: 7, label: 'Julho' },
            { value: 8, label: 'Agosto' },
            { value: 9, label: 'Setembro' },
            { value: 10, label: 'Outubro' },
            { value: 11, label: 'Novembro' },
            { value: 12, label: 'Dezembro' }
        ];
    };

    const generateYears = () => {
        const years = [];
        const currentYear = new Date().getFullYear();
        // maxYear: ano mais recente (padrão: ano atual)
        // minYear: ano mais antigo permitido (padrão: 100 anos atrás)
        const startYear = maxYear !== null ? maxYear : currentYear;
        const endYear = minYear !== null ? minYear : (currentYear - 100);
        // Generate years from startYear going back to endYear
        for (let i = startYear; i >= endYear; i--) {
            years.push(i);
        }
        return years;
    };

    // Reset day if it's invalid for the selected month/year
    useEffect(() => {
        if (month && year && day) {
            const maxDays = new Date(year, month, 0).getDate();
            if (day > maxDays) {
                setDay('');
            }
        }
    }, [month, year, day]);

    // Update parent when day, month, or year changes
    useEffect(() => {
        if (day && month && year) {
            const dayStr = String(day).padStart(2, '0');
            const monthStr = String(month).padStart(2, '0');
            const dateStr = `${year}-${monthStr}-${dayStr}`;
            if (onChange) {
                onChange(dateStr);
            }
        } else {
            if (onChange) {
                onChange(undefined);
            }
        }
    }, [day, month, year]);

    return (
        <>
            <select 
                ref={dayRef}
                value={day || ''}
                onChange={(e) => {
                    const selectedDay = e.target.value ? parseInt(e.target.value) : '';
                    setDay(selectedDay);
                }}
                style={{marginRight: '5px'}}
            >
                <option value="">Dia</option>
                {generateDays().map(d => (
                    <option key={d} value={d}>{d}</option>
                ))}
            </select>
            <select 
                ref={monthRef}
                value={month || ''}
                onChange={(e) => setMonth(e.target.value ? parseInt(e.target.value) : '')}
                style={{marginRight: '5px'}}
            >
                <option value="">Mês</option>
                {generateMonths().map(m => (
                    <option key={m.value} value={m.value}>{m.label}</option>
                ))}
            </select>
            <select 
                ref={yearRef}
                value={year || ''}
                onChange={(e) => setYear(e.target.value ? parseInt(e.target.value) : '')}
            >
                <option value="">Ano</option>
                {generateYears().map(y => (
                    <option key={y} value={y}>{y}</option>
                ))}
            </select>
        </>
    );
};

export default DateSelector;

